import { ArrowRight } from 'lucide-react';
import { Button } from './ui';

export function FreeSignupDialog({
  onRegister,
  onDismiss,
}: {
  onRegister: () => void;
  onDismiss: () => void;
}) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="free-signup-title"
      className="app-dialog bg-surface shadow-pop w-full max-w-md p-6 sm:p-8"
    >
      <h2 id="free-signup-title" className="font-heading text-xl sm:text-2xl font-bold text-ink mb-2">
        Create an account for free
      </h2>
      <p className="text-sm text-ink-soft mb-6">
        Registration is free.
      </p>
      <div className="flex flex-col gap-2">
        <Button className="w-full" size="lg" onClick={onRegister}>
          Register for free
          <ArrowRight className="w-4 h-4" aria-hidden />
        </Button>
        <Button className="w-full" variant="ghost" onClick={onDismiss}>
          I’ll check later
        </Button>
      </div>
    </div>
  );
}
